import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
var NESTED_METRIC_SEPARATOR = '/';
function filterEntry(entry) {
  return !(!entry || _typeof(entry) !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function mapEntry(entry) {
  return _objectSpread({
    startTime: Math.round(entry.startTime),
    duration: Math.round(entry.duration)
  }, entry.size && fg('platform_ufo_ssr_size_field') ? {
    size: Math.round(entry.size)
  } : {});
}
var SSR_PREFIX = 'ssr';
function mapKey(key) {
  if (key === 'total') {
    return SSR_PREFIX;
  }
  return "".concat(SSR_PREFIX).concat(NESTED_METRIC_SEPARATOR).concat(key);
}
var config;
export function configure(ssrConfig) {
  config = ssrConfig;
}
export function getSSRTimings() {
  var _config;
  if (!((_config = config) !== null && _config !== void 0 && _config.getTimings)) {
    return {};
  }
  var timings = config.getTimings();
  if (!timings) {
    return {};
  }
  var ssrTimings = Object.entries(timings).reduce(function (acc, entry) {
    if (filterEntry(entry[1])) {
      acc[mapKey(entry[0])] = mapEntry(entry[1]);
    }
    return acc;
  }, {});
  return ssrTimings;
}
export function getSSRSuccess() {
  var _config2;
  return !!((_config2 = config) !== null && _config2 !== void 0 && _config2.getDoneMark());
}
export function getSSRPhaseSuccess() {
  var _config3, _config3$getSsrPhaseS;
  return (_config3 = config) === null || _config3 === void 0 || (_config3$getSsrPhaseS = _config3.getSsrPhaseSuccess) === null || _config3$getSsrPhaseS === void 0 ? void 0 : _config3$getSsrPhaseS.call(_config3);
}
export function getSSRDoneTime() {
  var _config$getDoneMark, _config4;
  return (_config$getDoneMark = (_config4 = config) === null || _config4 === void 0 ? void 0 : _config4.getDoneMark()) !== null && _config$getDoneMark !== void 0 ? _config$getDoneMark : undefined;
}
export function getSSRFeatureFlags() {
  var _config5;
  if (!((_config5 = config) !== null && _config5 !== void 0 && _config5.getFeatureFlags)) {
    return undefined;
  }
  try {
    var _config$getFeatureFla;
    return (_config$getFeatureFla = config.getFeatureFlags()) !== null && _config$getFeatureFla !== void 0 ? _config$getFeatureFla : undefined;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return undefined;
}